<template>
  <v-container class="d-flex align-center justify-center fluid fill-height">
    <v-card width="380" flat outlined class="pa-2 mt-10">
      <v-card-title class="headline font-weight-bold">
        Reset Password
      </v-card-title>
      <form-wrapper @submit="submit">
        <v-card-text class="pt-0">
          <password-field
            v-model="password"
            label="New Password"
            rules="password"
          >
          </password-field>
          <password-field
            v-model="confirmPassword"
            label="Confirm New Password"
            :rules="`passwordConfirm:${password}`"
          >
          </password-field>
        </v-card-text>
        <v-card-actions class="pa-3 pt-0 flex-column">
          <primary-button type="submit" class="mb-3" block :loading="loading">
            Submit
          </primary-button>
        </v-card-actions>
      </form-wrapper>
    </v-card>
  </v-container>
</template>

<script>
import FormWrapper from "../../components/ui/form/FormWrapper.vue";
import PrimaryButton from "../../components/ui/buttons/PrimaryButton.vue";
import {functions} from "@/assets/utils/firebase.utils.js";
import PasswordField from "@/components/ui/form/PasswordField.vue";
import rulesConstants from "@/assets/constants/rules.constants";
import {httpsCallable} from "firebase/functions";

export default {
  computed: {
    rulesConstants() {
      return rulesConstants;
    },
  },
  components: { PasswordField, FormWrapper, PrimaryButton },
  data() {
    return {
      password: "",
      confirmPassword: "",
      loading: false,
    };
  },
  methods: {
    async submit() {
      try {
        this.loading = this;
        const passwordResetController = httpsCallable(functions, "manageAffiliate");
        const response = await passwordResetController({
          action: "set_password",
          data: {
            password: this.password,
            id: this.$store.getters.uid,
          }
        });
        const data = response.data;
        if (data.status) {
          this.notifySuccess(data.message);
          await this.$router.push({name: "clients"});
        } else {
          this.notifyError(data.message);
        }
      } catch (error) {
        this.notifyError(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
